import { Suspense, useEffect } from "react";
import { useQueryLoader } from "react-relay";

import { Loader } from "@whoosh/design-system/src/components/display";

import { PaymentMethods, PaymentMethodsQueryString } from "./PaymentMethods";
import { PaymentMethodsQuery } from "./__generated__/PaymentMethodsQuery.graphql";

type PaymentMethodsModalQueryWrapperProps = {
  setIsAddACardModalOpen: (isOpen: boolean) => void;
  setIsPaymentMethodsModalOpen: (isOpen: boolean) => void;
};

export const PaymentMethodsModalQueryWrapper = ({
  setIsAddACardModalOpen,
  setIsPaymentMethodsModalOpen,
}: PaymentMethodsModalQueryWrapperProps) => {
  const [queryRef, loadPaymentMethodQuery] =
    useQueryLoader<PaymentMethodsQuery>(PaymentMethodsQueryString);

  useEffect(() => {
    loadPaymentMethodQuery({}, { fetchPolicy: "network-only" });
  }, [loadPaymentMethodQuery]);

  const refreshQuery = () => {
    loadPaymentMethodQuery({}, { fetchPolicy: "network-only" });
  };

  return (
    <Suspense fallback={<Loader />}>
      {queryRef ? (
        <PaymentMethods
          queryRef={queryRef}
          setIsAddACardModalOpen={setIsAddACardModalOpen}
          setIsPaymentMethodsModalOpen={setIsPaymentMethodsModalOpen}
          refreshQuery={refreshQuery}
        />
      ) : null}
    </Suspense>
  );
};
